export enum VideoHeartbeatPlayerType {
	FLASH = 'Flash',
	HTML5 = 'HTML5'
}
